import React, { useState } from 'react';
import { Box, Button, Menu, MenuItem, TextField } from '@mui/material';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import moment from 'moment';

const DateRangeSelector = ({ dateRange, onDateRangeChange }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [customRange, setCustomRange] = useState({
    startDate: dateRange.startDate,
    endDate: dateRange.endDate
  });
  
  const open = Boolean(anchorEl);
  
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  
  const handleClose = () => {
    setAnchorEl(null);
  };
  
  const handleCustomStartDateChange = (event) => {
    setCustomRange({
      ...customRange,
      startDate: new Date(event.target.value)
    });
  };
  
  const handleCustomEndDateChange = (event) => {
    setCustomRange({
      ...customRange,
      endDate: new Date(event.target.value)
    });
  };
  
  const applyCustomRange = () => {
    onDateRangeChange(customRange);
    handleClose();
  };
  
  const selectPredefinedRange = (days) => {
    const endDate = new Date();
    const startDate = new Date();
    startDate.setDate(startDate.getDate() - days);
    
    onDateRangeChange({
      startDate,
      endDate
    });
    
    handleClose();
  };
  
  const formatDate = (date) => {
    return moment(date).format('DD/MM/YYYY');
  };
  
  return (
    <Box>
      <Button
        variant="outlined"
        onClick={handleClick}
        startIcon={<CalendarTodayIcon />}
        endIcon={<ArrowDropDownIcon />}
      >
        {formatDate(dateRange.startDate)} - {formatDate(dateRange.endDate)}
      </Button>
      
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem onClick={() => selectPredefinedRange(7)}>Últimos 7 dias</MenuItem>
        <MenuItem onClick={() => selectPredefinedRange(30)}>Últimos 30 dias</MenuItem>
        <MenuItem onClick={() => selectPredefinedRange(90)}>Últimos 90 dias</MenuItem>
        
        <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', minWidth: 240 }}>
          <Box sx={{ mb: 2 }}>
            <TextField
              label="Data início"
              type="date"
              value={moment(customRange.startDate).format('YYYY-MM-DD')}
              onChange={handleCustomStartDateChange}
              fullWidth
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          
          <Box sx={{ mb: 2 }}>
            <TextField
              label="Data fim"
              type="date"
              value={moment(customRange.endDate).format('YYYY-MM-DD')}
              onChange={handleCustomEndDateChange}
              fullWidth
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          
          <Button variant="contained" onClick={applyCustomRange}>
            Aplicar
          </Button>
        </Box>
      </Menu>
    </Box>
  );
};

export default DateRangeSelector;
